import { twMerge } from 'tailwind-merge';
import { PhotoCredit } from 'aslan';
import { StoryCardImageLayoutEnum, StoryCardTypeEnum } from '../../../models';
import { cardImageUrl } from '../../../services/cloudflare';
function imageLayoutVariables(image, imageLayout) {
    return {
        inlineImage: image &&
            (imageLayout === StoryCardImageLayoutEnum.TOP ||
                imageLayout === StoryCardImageLayoutEnum.BOTTOM),
        imageAtTop: image && imageLayout === StoryCardImageLayoutEnum.TOP,
        imageAtBottom: image && imageLayout === StoryCardImageLayoutEnum.BOTTOM,
        imageAsFrame: image && imageLayout === StoryCardImageLayoutEnum.FRAME,
        imageAsFull: image && imageLayout === StoryCardImageLayoutEnum.FULL,
        noImage: !image || imageLayout === StoryCardImageLayoutEnum.NONE,
    };
}
export const BaseCard = ({ element, card, enableProgression, fullScreenOnMobile = false, className, }) => {
    const { image, imageLayout = StoryCardImageLayoutEnum.NONE, styles } = card;
    const { inlineImage, imageAtTop, imageAtBottom, imageAsFrame, imageAsFull, noImage, } = imageLayoutVariables(image, imageLayout);
    const ChildCard = element;
    const overImagePhotoCredit = inlineImage && !image?.cloudflareId && image?.unsplashPhoto?.user;
    const cardBottomPhotoCredit = !inlineImage && !image?.cloudflareId && image?.unsplashPhoto?.user;
    const cardContainerClassName = twMerge('flex justify-start overflow-hidden', fullScreenOnMobile
        ? 'w-screen h-screen sm:max-w-xs sm:aspect-video-vertical sm:h-fit'
        : 'max-w-xs aspect-video-vertical max-w-xs', imageAtBottom ? 'flex-col-reverse' : 'flex-col', className);
    const cardContainerStyle = {
        backgroundColor: styles?.background.color,
        ...((imageAsFull || imageAsFrame) && {
            backgroundImage: `url(${cardImageUrl(image)})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }),
    };
    const isTextCenter = (variant) => {
        return ([
            StoryCardTypeEnum.TEXT,
            StoryCardTypeEnum.LINK,
            StoryCardTypeEnum.RICH_TEXT,
        ].indexOf(variant) > -1);
    };
    const childrenContainerClassName = twMerge('flex flex-col h-full justify-items-center overflow-hidden', imageAtTop ? 'justify-start' : '', imageAtBottom ? 'justify-start' : '', imageAsFull ? 'bg-clip-content' : '', imageAsFull && isTextCenter(card.variant)
        ? 'justify-center'
        : 'justify-start', imageAsFrame ? 'justify-start m-6' : '', noImage && isTextCenter(card.variant) ? 'justify-center' : '');
    const childrenContainerStyle = imageAsFrame && styles?.background.color
        ? {
            background: styles.background.color,
        }
        : {};
    const titleClassName = twMerge('font-serif text-3xl px-6 my-7', imageAsFull ? 'bg-clip-content' : '');
    const titleStyle = {
        color: styles?.title?.color,
    };
    const textClassName = twMerge('font-sans text-sm px-6', imageAsFull ? 'bg-clip-content' : '');
    const textStyle = {
        color: styles?.text?.color,
    };
    const buttonStyle = styles?.button
        ? {
            color: styles.button.color,
            background: styles.button.background,
            borderColor: styles.button.color,
        }
        : undefined;
    const cardStyle = styles?.card
        ? {
            color: styles.card.color,
            background: styles.card.background,
            borderColor: styles.card.color,
        }
        : undefined;
    const inputStyle = styles?.input
        ? {
            color: styles.input.color,
            background: styles.input.background,
            borderColor: styles.input.color,
        }
        : undefined;
    return (<div className={cardContainerClassName} style={cardContainerStyle}>
      {inlineImage && image?.cloudflareId && (<img alt="course card background" className="object-cover w-full" style={{ height: '50%' }} src={cardImageUrl(image)}/>)}
      {overImagePhotoCredit && image?.unsplashPhoto && (<div className="relative w-full" style={{ height: '50%' }}>
          <img alt="course card background" className="object-cover w-full" src={cardImageUrl(image)}/>

          <PhotoCredit artist={{
                name: image.unsplashPhoto?.user?.name,
                url: `https://unsplash.com/@${image.unsplashPhoto.user?.username}?utm_source=theleap&utm_medium=referral`,
            }} platform={{
                name: 'Unsplash',
                url: 'https://unsplash.com/?utm_source=theleap&utm_medium=referral',
            }}/>
        </div>)}

      <div className={childrenContainerClassName} style={childrenContainerStyle}>
        <ChildCard titleClassName={titleClassName} titleStyle={titleStyle} textClassName={textClassName} textStyle={textStyle} enableProgression={enableProgression} buttonStyle={buttonStyle} cardStyle={cardStyle} inputStyle={inputStyle} {...{ ...card }}/>
      </div>

      {cardBottomPhotoCredit && image?.unsplashPhoto && (<PhotoCredit artist={{
                name: image.unsplashPhoto?.user?.name,
                url: `https://unsplash.com/@${image.unsplashPhoto.user?.username}?utm_source=theleap&utm_medium=referral`,
            }} platform={{
                name: 'Unsplash',
                url: 'https://unsplash.com/?utm_source=theleap&utm_medium=referral',
            }}/>)}
    </div>);
};
export default BaseCard;
